import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      transform="translate(9 4) scale(1.2 1.2)"
      d="M2.50065 3.66732C3.41732 3.66732 4.16732 2.91732 4.16732 2.00065C4.16732 1.08398 3.41732 0.333984 2.50065 0.333984C1.58398 0.333984 0.833984 1.08398 0.833984 2.00065C0.833984 2.91732 1.58398 3.66732 2.50065 3.66732ZM2.50065 5.33398C1.58398 5.33398 0.833984 6.08398 0.833984 7.00065C0.833984 7.91732 1.58398 8.66732 2.50065 8.66732C3.41732 8.66732 4.16732 7.91732 4.16732 7.00065C4.16732 6.08398 3.41732 5.33398 2.50065 5.33398ZM2.50065 10.334C1.58398 10.334 0.833984 11.084 0.833984 12.0007C0.833984 12.9173 1.58398 13.6673 2.50065 13.6673C3.41732 13.6673 4.16732 12.9173 4.16732 12.0007C4.16732 11.084 3.41732 10.334 2.50065 10.334Z"
      fill={fill}
    />
  </g>
);

export default Icon;
